import { createSlice } from "@reduxjs/toolkit";

const getStored = (key, fallback) => {
  try {
    const value = localStorage.getItem(key);

    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
};

const initialState = {
  country_code: getStored("country_code", ""),
  isEuro: false,
};

const countrySlice = createSlice({
  name: "country_code",
  initialState,
  reducers: {
    setCountry: (state, action) => {
      state.country_code = action.payload;
      localStorage.setItem("country_code", JSON.stringify(action.payload));
    },
    setIsEuro: (state, action) => {
      state.isEuro = action.payload;
    },
  },
});

export const { setCountry, setIsEuro } = countrySlice.actions;

export default countrySlice.reducer;
